import React from 'react';
import { PageTitle } from '@fasstech/middle-design-system';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';

// Vue provisoire du parcours prévoyance collective : titre + navigation
const SkeletonView = ({
  title,
  getMiddleText,
  displayPreviousButton = true,
  nextButtonIsHidden = false
}) => {
  const { context, processHandlers } = useProcess();
  const transitionContext = { context: { projectId: context?.projectId } };

  return (
    <div className={'w-full'}>
      <PageLayout>
        <PageTitle>{title}</PageTitle>
      </PageLayout>
      <ButtonContainer
        $onPreviousButtonClick={() => processHandlers.onPrev(transitionContext)}
        $onNextButtonClick={() => processHandlers.onNext(transitionContext)}
        nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
        displayPreviousButton={displayPreviousButton}
        nextButtonIsHidden={nextButtonIsHidden}
        getMiddleText={getMiddleText}
      />
    </div>
  );
};

export default SkeletonView;
